import { useAccess } from "@templates/course/hooks/useAccess";
import Image from "next/image";
import { FC } from "react";
import { useIsMobile } from "@shared/hooks/useIsMobile";

const certificateImageAddressMobile =
  "https://faradars.org/wp-content/uploads/2026/07/14/product-certificate-card-mob-optimized.svg";

const HasCertificateCard: FC = () => {
  const { courseData } = useAccess();
  const isMobile = useIsMobile();
  const {
    product: { hasCertificate },
  } = courseData;
  if (!hasCertificate) return null;

  return (
    <div className="py-6  md:py-8">
      <section className=" certificate-banner  relative flex flex-col-reverse md:items-center md:flex-row justify-between rounded-12 overflow-hidden gap-5    md:gap-12 p-6  md:py-0 md:px-8   md:h-[224px]">
        <div className="absolute top-0 md:bottom-0 left-0 right-0 md:right-auto flex flex-col md:flex-row-reverse">
          {Array(4)
            .fill("")
            .map((_item, index) => (
              <div
                key={index}
                className="w-full md:w-11  h-fds-30 md:h-full bg-fds-brand-light-select"
                style={{ opacity: String(0.3 + index / 10) }}
              />
            ))}
        </div>
        <div className="flex flex-col justify-center gap-2">
          <p className="text-fds-primary font-semibold headline-sm md:headline-md">
            گواهی‌نامه دوزبانه پایان دوره
          </p>
          <p className="text-fds-primary text-right body-md">
            <span className=" md:inline hidden">
              با کسب نمره قبولی در آزمون‌ها، گواهینامه رسمی پایان دوره به دو
              زبان {" "}
            </span>
            <span className="inline md:hidden">
              با کسب نمره قبولی، گواهی‌نامه پایان دوره به دو زبان{" "}
            </span>
            <span className="title-md-demibold">فارسی</span> و {" "}
            <span className="title-md-demibold">انگلیسی</span>{" "}
            <span className=" md:inline hidden">
              به شما اعطا می‌شود. علاوه بر دانلود و ذخیره، امکان اشتراک‌گذاری
              مستقیم گواهینامه در لینکدین نیز فراهم است.
            </span>
            <span className=" md:hidden inline">
              و با امکان به اشتراک‌گذاری در لینکدین و سایت‌های کاریابی به شما
              اعطا می‌گردد.
            </span>
          </p>
        </div>
        <div className="md:min-w-fit md:-ml-2">
          {isMobile ? (
            <div className="relative w-full aspect-video fds-sm:h-52">
              <Image
                fill
                src={certificateImageAddressMobile}
                alt="certificate"
                className="object-contain"
              />
            </div>
          ) : (
            <Image
              src={certificateImageAddressMobile}
              width={254}
              height={172}
              alt="certificate"
              className="relative z-10"
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default HasCertificateCard;
